/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type NotFoundResult,
    NotFoundResultFromJSON,
    NotFoundResultToJSON,
} from '../models/NotFoundResult';
import {
    type UserMigrationApplicationResponse,
    UserMigrationApplicationResponseFromJSON,
    UserMigrationApplicationResponseToJSON,
} from '../models/UserMigrationApplicationResponse';
import {
    type UserMigrationMigrateRequest,
    UserMigrationMigrateRequestFromJSON,
    UserMigrationMigrateRequestToJSON,
} from '../models/UserMigrationMigrateRequest';
import {
    type UserMigrationQueryRequest,
    UserMigrationQueryRequestFromJSON,
    UserMigrationQueryRequestToJSON,
} from '../models/UserMigrationQueryRequest';
import {
    type UserMigrationQueryResponse,
    UserMigrationQueryResponseFromJSON,
    UserMigrationQueryResponseToJSON,
} from '../models/UserMigrationQueryResponse';
import {
    type UserMigrationStatusResponse,
    UserMigrationStatusResponseFromJSON,
    UserMigrationStatusResponseToJSON,
} from '../models/UserMigrationStatusResponse';
import {
    type UserMigrationStatusUpdateRequest,
    UserMigrationStatusUpdateRequestFromJSON,
    UserMigrationStatusUpdateRequestToJSON,
} from '../models/UserMigrationStatusUpdateRequest';

export interface ApiUserMigrationMigratePostRequest {
    userMigrationMigrateRequest: UserMigrationMigrateRequest;
}

export interface ApiUserMigrationQueryPostRequest {
    userMigrationQueryRequest: UserMigrationQueryRequest;
}

export interface ApiUserMigrationStatusPutRequest {
    userMigrationStatusUpdateRequest: UserMigrationStatusUpdateRequest;
}

/**
 * 
 */
export class UserMigrationApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiUserMigrationApplicationsGet without sending the request
     */
    async apiUserMigrationApplicationsGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/user-migration/applications`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUserMigrationApplicationsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMigrationApplicationResponse>>> {
        const requestOptions = await this.apiUserMigrationApplicationsGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMigrationApplicationResponseFromJSON));
    }

    /**
     */
    async apiUserMigrationApplicationsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMigrationApplicationResponse>> {
        const response = await this.apiUserMigrationApplicationsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUserMigrationMigratePost without sending the request
     */
    async apiUserMigrationMigratePostRequestOpts(requestParameters: ApiUserMigrationMigratePostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userMigrationMigrateRequest'] == null) {
            throw new runtime.RequiredError(
                'userMigrationMigrateRequest',
                'Required parameter "userMigrationMigrateRequest" was null or undefined when calling apiUserMigrationMigratePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-migration/migrate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMigrationMigrateRequestToJSON(requestParameters['userMigrationMigrateRequest']),
        };
    }

    /**
     */
    async apiUserMigrationMigratePostRaw(requestParameters: ApiUserMigrationMigratePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUserMigrationMigratePostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserMigrationMigratePost(requestParameters: ApiUserMigrationMigratePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserMigrationMigratePostRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for apiUserMigrationQueryPost without sending the request
     */
    async apiUserMigrationQueryPostRequestOpts(requestParameters: ApiUserMigrationQueryPostRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userMigrationQueryRequest'] == null) {
            throw new runtime.RequiredError(
                'userMigrationQueryRequest',
                'Required parameter "userMigrationQueryRequest" was null or undefined when calling apiUserMigrationQueryPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-migration/query`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMigrationQueryRequestToJSON(requestParameters['userMigrationQueryRequest']),
        };
    }

    /**
     */
    async apiUserMigrationQueryPostRaw(requestParameters: ApiUserMigrationQueryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMigrationQueryResponse>>> {
        const requestOptions = await this.apiUserMigrationQueryPostRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMigrationQueryResponseFromJSON));
    }

    /**
     */
    async apiUserMigrationQueryPost(requestParameters: ApiUserMigrationQueryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMigrationQueryResponse>> {
        const response = await this.apiUserMigrationQueryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUserMigrationStatusGet without sending the request
     */
    async apiUserMigrationStatusGetRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/user-migration/status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiUserMigrationStatusGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMigrationStatusResponse>> {
        const requestOptions = await this.apiUserMigrationStatusGetRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMigrationStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserMigrationStatusGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMigrationStatusResponse> {
        const response = await this.apiUserMigrationStatusGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiUserMigrationStatusPut without sending the request
     */
    async apiUserMigrationStatusPutRequestOpts(requestParameters: ApiUserMigrationStatusPutRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userMigrationStatusUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'userMigrationStatusUpdateRequest',
                'Required parameter "userMigrationStatusUpdateRequest" was null or undefined when calling apiUserMigrationStatusPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/user-migration/status`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserMigrationStatusUpdateRequestToJSON(requestParameters['userMigrationStatusUpdateRequest']),
        };
    }

    /**
     */
    async apiUserMigrationStatusPutRaw(requestParameters: ApiUserMigrationStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.apiUserMigrationStatusPutRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiUserMigrationStatusPut(requestParameters: ApiUserMigrationStatusPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiUserMigrationStatusPutRaw(requestParameters, initOverrides);
    }

}
